// extracted by mini-css-extract-plugin
export var image = "sidebar-item-module--image--d841f";
export var imageWrap__podcast = "sidebar-item-module--imageWrap__podcast--3e9c8";
export var item = "sidebar-item-module--item--f8749";
export var item__auto = "sidebar-item-module--item__auto--46c3e";
export var item__link = "sidebar-item-module--item__link--3c34c";
export var spin = "sidebar-item-module--spin--cc617";
export var storyType = "sidebar-item-module--storyType--18733";